import type { JSX } from '@builder.io/qwik';
import { component$, useVisibleTask$ } from '@builder.io/qwik';
import { getPlayerTypeByVersion } from '~/utilities/getPlayerTypeByVersion';

export default component$(
  ({ html, version }: { html: string; version?: string }): JSX.Element => {
    const playerType = getPlayerTypeByVersion(version ?? '');

    // eslint-disable-next-line qwik/no-use-visible-task
    useVisibleTask$(() => {
      const loadMiniPlayerScript = () => {
        if (window.mmMiniPlayerLoaded) {
          return;
        }
        window.mmMiniPlayerLoaded = true;

        loadScript(
          'https://vms-players.minutemediaservices.com/voltax_player_embed_mount.js'
        );
      };

      const loadOldPlayerScript = () => {
        if (window.mmOldPlayerLoaded) {
          return;
        }
        window.mmOldPlayerLoaded = true;

        loadScript(
          'https://vms-players.minutemediaservices.com/mplayer_embed_mount.js'
        );
      };

      const loadScript = (src: string) => {
        const script = document.createElement('script');
        script.src = src;
        script.defer = true;
        document.head.appendChild(script);
      };

      const loadMMPlayerEmbedsScript = () => {
        if (playerType === 'mini') loadMiniPlayerScript();
        if (playerType !== 'mini') loadOldPlayerScript();
      };

      loadMMPlayerEmbedsScript();
    });

    return (
      <figure
        class='mm-player-embed aspect-video relative w-full bg-black [&>iframe]:absolute [&>iframe]:top-0 [&>iframe]:left-0 [&>iframe]:w-full [&>iframe]:h-full [&>iframe]:border-0'
        data-player-type={playerType}
        dangerouslySetInnerHTML={html}
      />
    );
  }
);
